import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { formSendAction } from "../../../Engine/ActionCreators/FormActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { FormDebugTools } from "./FormDebugTools";

const mapStateToProps = (state: FullFormState) => ({
    isReadOnly: state.settings.isReadOnly,
    isIndividual: state.settings.isIndividual,
    isDisabledCleanForm: state.settings.isDisabledCleanForm,
    isDebug: state.settings.debug,
});
const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onSendForm: () => dispatch(formSendAction),
});

export const FormDebugToolsContainer = connect(mapStateToProps, mapDispatchToProps)(FormDebugTools);
